var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroller"},[_c('Scroller',{key:_vm.renderKey,attrs:{"color":"symptom","options":_vm.labels},model:{value:(_vm.labelValue),callback:function ($$v) {_vm.labelValue=$$v},expression:"labelValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }